import { Type } from '@sinclair/typebox';
export var SupportedOperation;
(function (SupportedOperation) {
    SupportedOperation["Buy"] = "buy";
    SupportedOperation["Sell"] = "sell";
    SupportedOperation["PoolInit"] = "poolInit";
    SupportedOperation["LiquidityAdd"] = "liquidityAdd";
    SupportedOperation["LiquidityRemove"] = "liquidityRemove";
    SupportedOperation["PoolMigrate"] = "poolMigrate";
    SupportedOperation["LpBurn"] = "lpBurn";
    SupportedOperation["QuoteBurn"] = "quoteBurn";
})(SupportedOperation || (SupportedOperation = {}));
export const SupportedOperationSchema = Type.Enum(SupportedOperation);
//# sourceMappingURL=supported-operation.js.map